import React from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";

import LogRocket from "./../../helpers/logrocket";
import { postRequest } from "../../config/dataApi";
import ENDPOINTS from "../../config/apiUrls";
import { toast } from "react-toastify";

const Support = ({ hideContactSubheading = false }) => {
  const getSessionUrl = async () => {
    try {
      return await new Promise((resolve) => {
        LogRocket.getSessionURL((sessionUrl) => resolve(sessionUrl));
      });
    } catch (err) {
      throw err;
    }
  };

  const formik = useFormik({
    initialValues: {
      subject: "",
      message: "",
    },
    validationSchema: Yup.object({
      subject: Yup.string()
        .required("Subject is required")
        .min(5, "Subject must be at least 5 characters"),
      message: Yup.string()
        .required("Message is required")
        .min(10, "Message must be at least 10 characters"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const sessionUrl = await getSessionUrl().catch(() => "(blocked)");

        await postRequest(ENDPOINTS.SUPPORT.CONTACT, {
          data: {
            type: "support",
            attributes: {
              subject: values.subject,
              message: values.message,
              sessionUrl,
            },
          },
        });

        // Reset the form after successful submission
        resetForm();

        // Show a success toast
        toast.success("Your support request has been sent successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } catch (error) {
        console.error("Error sending support request:", error);
        toast.error("An error occurred. Please try again.", {
          position: "top-right",
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    },
  });

  return (
    <div className="section_main_div">
      <h1 className="section_heading">Support</h1>
      {!hideContactSubheading ? (
        <div className="section_sub_heading">
          <Link to="#" className="active">
            Contact
          </Link>
        </div>
      ) : null}
      <form className="form_div" onSubmit={formik.handleSubmit}>
        <div className="form-card">
          <div className="form-elements">
            <div className="custom-form-group">
              <label htmlFor="subject">Subject</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formik.values.subject}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                autoComplete="off"
                required
              />
              {formik.touched.subject && formik.errors.subject ? (
                <div className="error-text">{formik.errors.subject}</div>
              ) : null}
              <hr
                className={
                  formik.touched.message && formik.errors.message
                    ? "error-hr-line"
                    : ""
                }
              />
            </div>
            <div className="custom-form-group">
              <label htmlFor="message">Message</label>
              <input
                type="text"
                id="message"
                name="message"
                value={formik.values.message}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                autoComplete="off"
                required
              />

              {formik.touched.message && formik.errors.message ? (
                <div className="error-text">{formik.errors.message}</div>
              ) : null}
              <hr
                className={
                  formik.touched.message && formik.errors.message
                    ? "error-hr-line"
                    : ""
                }
              />
            </div>
          </div>
        </div>
        <div className="text-right">
          <div className="button-div">
            <button type="submit" disabled={formik.isSubmitting}>
              <span>{formik.isSubmitting ? "Sending..." : "Send"}</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Support;
